import React from "react"
import { DropdownButton } from "react-bootstrap"
import Dropdown from "react-bootstrap/Dropdown"
import { Container, Row, Col } from "reactstrap"
import { isSameColumn, normalizeColumnValue } from "./columnSelectionUtils"
export default function TemplateBodyVars({
  columns,
  bodyVars,
  selectedOptions,
  selectedButtonOptions,
  isSubmitted,
  selectFileColumn,
  selectNumber,
  selectedColumnHeader,
  handleSelect,
}) {
  const normalizedSelectedOptions = selectedOptions.map(normalizeColumnValue)
  const normalizedSelectedButtonOptions = selectedButtonOptions.map(
    normalizeColumnValue
  )

  return (
    <Row>
      {bodyVars && (
        <>
          <Container
            style={{
              direction: "ltr",
            }}
          >
            {bodyVars.map((bodyVarInput, idx) => (
              <>
                <Container
                  key={idx}
                  className="input-group input-group-sm my-1 d-flex justify-content-around mt-2 gap-1"
                >
                  {/* input var number */}{" "}
                  <Col
                    style={{
                      color: "#2a3042",
                      borderRadius: "5px",
                      fontWeight: "bold",
                    }}
                    className=" bg-white d-flex justify-content-center align-items-center col-2 "
                    id="inputGroup-sizing-sm"
                  >
                    {`input: {{${idx + 1}}}`}
                  </Col>
                  <Col>
                    <DropdownButton
                      className="dropdown-toggle-temp-preview-var  border rounded-3"
                      style={{
                        background: "white",
                        margin: "0",
                        direction: "ltr",
                      }}
                      // title="▼"
                      title={
                        <>
                          <div
                            style={{
                              backgroundColor: "white",
                              width: "40vw",
                            }}
                            className=" d-flex justify-content-between align-items-center p-1"
                          >
                            {selectedOptions[idx] ? (
                              <p
                                style={{
                                  color: selectedOptions ? "black" : "#ACB4BF",
                                }}
                                className="mb-0"
                              >
                                {normalizeColumnValue(selectedOptions[idx])}
                              </p>
                            ) : (
                              <p
                                style={{
                                  color: "#ACB4BF",
                                }}
                                className="mb-0"
                              >
                                Choose the respective column
                              </p>
                            )}
                            <i
                              style={{
                                color: "#ACB4BF",
                              }}
                              className="fas fa-chevron-down"
                            ></i>
                          </div>
                        </>
                      }
                    >
                      {columns.map((column, index) => {
                        const normalizedColumn = normalizeColumnValue(column)

                        return (
                          <Dropdown.Item
                            disabled={
                              isSameColumn(selectFileColumn, normalizedColumn) ||
                              isSameColumn(selectNumber, normalizedColumn) ||
                              isSameColumn(
                                selectedColumnHeader,
                                normalizedColumn
                              ) ||
                              normalizedSelectedButtonOptions.includes(
                                normalizedColumn
                              ) ||
                              (normalizedSelectedOptions.includes(
                                normalizedColumn
                              ) &&
                                normalizedSelectedOptions[idx] !==
                                  normalizedColumn)
                            }
                            onClick={() => handleSelect(normalizedColumn, idx)}
                            className="DropdownItem  "
                            key={`${normalizedColumn}-${index}`}
                          >
                            {normalizedColumn}
                          </Dropdown.Item>
                        )
                      })}
                    </DropdownButton>
                  </Col>
                </Container>
                {bodyVars && !selectedOptions[idx] && isSubmitted && (
                  <>
                    <Row>
                      <p
                        style={{
                          direction: "rtl",
                          textAlign: "right",
                        }}
                        className="text-danger mb-0"
                      >
                        required
                      </p>
                    </Row>
                  </>
                )}
              </>
            ))}
          </Container>
        </>
      )}
    </Row>
  )
}
